module.exports = __webpack_public_path__ + "static/media/noDelivery.dfbd27c2.svg";